import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const BuyIcon: React.FC<CardGradientProps> = ({
  className,
  width = "17",
  height = "17",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70898 9.29159V11.6666C7.70898 11.8909 7.78485 12.0789 7.93659 12.2306C8.08832 12.3824 8.27634 12.4583 8.50065 12.4583C8.72496 12.4583 8.91298 12.3824 9.06471 12.2306C9.21645 12.0789 9.29232 11.8909 9.29232 11.6666V9.29159H11.6673C11.8916 9.29159 12.0796 9.21572 12.2314 9.06398C12.3831 8.91225 12.459 8.72423 12.459 8.49992C12.459 8.27561 12.3831 8.08759 12.2314 7.93586C12.0796 7.78412 11.8916 7.70825 11.6673 7.70825H9.29232V5.33325C9.29232 5.10895 9.21645 4.92093 9.06471 4.76919C8.91298 4.61745 8.72496 4.54159 8.50065 4.54159C8.27634 4.54159 8.08832 4.61745 7.93659 4.76919C7.78485 4.92093 7.70898 5.10895 7.70898 5.33325V7.70825H5.33398C5.10968 7.70825 4.92166 7.78412 4.76992 7.93586C4.61819 8.08759 4.54232 8.27561 4.54232 8.49992C4.54232 8.72423 4.61819 8.91225 4.76992 9.06398C4.92166 9.21572 5.10968 9.29159 5.33398 9.29159H7.70898ZM8.50065 16.4166C7.40551 16.4166 6.37634 16.2088 5.41315 15.7931C4.44996 15.3775 3.61211 14.8135 2.89961 14.101C2.18711 13.3885 1.62305 12.5506 1.20742 11.5874C0.791797 10.6242 0.583984 9.59506 0.583984 8.49992C0.583984 7.40478 0.791797 6.37561 1.20742 5.41242C1.62305 4.44922 2.18711 3.61138 2.89961 2.89888C3.61211 2.18638 4.44996 1.62231 5.41315 1.20669C6.37634 0.791064 7.40551 0.583252 8.50065 0.583252C9.59579 0.583252 10.625 0.791064 11.5882 1.20669C12.5513 1.62231 13.3892 2.18638 14.1017 2.89888C14.8142 3.61138 15.3783 4.44922 15.7939 5.41242C16.2095 6.37561 16.4173 7.40478 16.4173 8.49992C16.4173 9.59506 16.2095 10.6242 15.7939 11.5874C15.3783 12.5506 14.8142 13.3885 14.1017 14.101C13.3892 14.8135 12.5513 15.3775 11.5882 15.7931C10.625 16.2088 9.59579 16.4166 8.50065 16.4166Z"
        fill="#CFB2FF"
      />
    </svg>
  );
};

export default BuyIcon;
